import "./NotFound.css";

function NotFound() {

  return (
    <div className="notfound-container">
      <div className="bg-circle circle-1"></div>
      <div className="bg-circle circle-2"></div>

      <div className="notfound-card">
        {/* <div className="icon">🚫</div> */}

        <h1 className="error-code">404</h1>

        <h2 className="title">
          ไม่พบหน้าที่คุณต้องการ
        </h2>

        <p className="description">
          URL นี้ไม่มีอยู่ในระบบ กรุณาติดต่อผู้ดูแลระบบ
        </p>
      </div>
    </div>
  );
}

export default NotFound;